import {useEffect, useState} from 'react';
import {InlineDatumReactComponentProps} from '@stripe-internal/inline-data';
import {Button, view} from '@sail/ui';
import {FormattedMessage, defineMessage} from 'react-intl';

export type ValueProps = {
  review_requested?: boolean;
};

const messages = {
  requestAReview: defineMessage({
    id: 'mse_inline_data.request_a_review.request_review',
    description: 'request a review cta',
    defaultMessage:
      'We noticed an elevated rate of recently blocked transactions on your account. If you believe these transactions have been blocked in error, you can request a review.',
  }),
  requestAReviewButton: defineMessage({
    id: 'mse_inline_data.request_a_review.request_review_button',
    description: 'request a review button',
    defaultMessage: 'Request a review',
  }),
  requestSubmitted: defineMessage({
    id: 'mse_inline_data.request_a_review.request_submitted',
    description: 'review request submitted confirmation',
    defaultMessage:
      'Thank you - we’ve received your request and will review your account shortly.',
  }),
  requestSubmittedButton: defineMessage({
    id: 'mse_inline_data.request_a_review.request_submitted_button',
    description: 'review request submitted button',
    defaultMessage: 'Review requested',
  }),
};

export const RequestAReview = (props: InlineDatumReactComponentProps) => {
  const {action, datum} = props;

  /* eslint-disable camelcase */
  const {review_requested} = datum.value as ValueProps;

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [reviewRequested, setReviewRequested] = useState<boolean>(
    review_requested || false,
  );

  useEffect(() => {
    if (review_requested !== undefined && review_requested !== null) {
      setReviewRequested(review_requested);
      if (review_requested) {
        setIsLoading(false);
      }
    }
  }, [review_requested]);
  /* eslint-enable camelcase */

  const handleRequestReview = async () => {
    setIsLoading(true);
    action();
  };

  return (
    <>
      <view.div>
        <FormattedMessage {...messages.requestAReview} />
        <br />
        <br />
        <Button
          type="secondary"
          onPress={handleRequestReview}
          pending={isLoading && !reviewRequested}
          disabled={reviewRequested || isLoading}
        >
          {reviewRequested ? (
            <FormattedMessage {...messages.requestSubmittedButton} />
          ) : (
            <FormattedMessage {...messages.requestAReviewButton} />
          )}
        </Button>
        {reviewRequested && (
          <>
            <br />
            <br />
            <view.div
              css={{
                marginBottom: 'medium',
                stack: 'y',
                alignX: 'center',
                color: 'form.placeholder',
                font: 'label.small',
                textAlign: 'center',
              }}
            >
              <FormattedMessage {...messages.requestSubmitted} />
            </view.div>
          </>
        )}
      </view.div>
    </>
  );
};
